import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const mobileLogin = (countryTelCd, mobileNumber) => {
    return new Promise((resolve, reject) => {
        var fdd = new FormData;
        fdd.append('countryTelCd', countryTelCd);
        fdd.append('mobileNumber', mobileNumber);
        axios({
          method : "POST",
          url :  api_url + "/public/MobileLogin",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const validateMobileLoginOTP = (countryTelCd, mobileNumber, pin) => {
    return new Promise((resolve, reject) => {
        var fdd = new FormData;
        fdd.append('countryTelCd', countryTelCd);
        fdd.append('mobileNumber', mobileNumber);
        fdd.append('pin', pin);
        axios({
          method : "POST",
          url :  api_url + "/public/ValidateMobileLoginOTP",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getLastMobileOTPActivity = (userCountry) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
          method : "GET",
          url :  api_url + "/GetLastMobileOTPActivity",
          params : {"userCountry": userCountry},
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const generateOTP = (countryTelCd, mobileNumber) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('countryTelCd', countryTelCd);
        fdd.append('mobileNumber', mobileNumber);
        axios({
          method : "POST",
          url :  api_url + "/GenerateOTP",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateMobileNumber = (countryTelCd, mobileNumber, accountType, pin, isMobileVerified) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
    	fdd.append('countryTelCd', countryTelCd);
    	fdd.append('mobileNumber', mobileNumber);
    	fdd.append('accountType', accountType);
    	fdd.append('pin', pin);
        fdd.append('isMobileVerified', isMobileVerified);
        axios({
          method : "POST",
          url :  api_url + "/UpdateMobileNumber",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const mobileLogStatus = (requestIdInt, logType, respondUserId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('logIdInt', requestIdInt);
        fdd.append('logType', logType);
        fdd.append('respondUserId', respondUserId);
        axios({
          method : "POST",
          url :  api_url + "/GetMobileLogStatus",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const logMobileAction = (logType, requestIdInt, respondUserId, requestUserId, actionTyp, newChipsAmount, mobileChipValue) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('logType', logType);
        fdd.append('logIdInt', requestIdInt);
        fdd.append('fromUserId', respondUserId);
        fdd.append('toUserId', requestUserId);
        fdd.append('actType', actionTyp);
        fdd.append('newChipsAmount', newChipsAmount);
        fdd.append('mobileChipValue', mobileChipValue);
        axios({
          method : "POST",
          url :  api_url + "/LogMobileAction",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getMobileNumber = (userId, accountType) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('userId', userId);
        fdd.append('accountType', accountType);
        axios({
          method : "POST",
          url :  api_url + "/GetMobileNumber",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateMobileNumberPrivacy = (accountType, hideMobileNumber) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('accountType', accountType);
        fdd.append('hideMobileNumber', hideMobileNumber);
        axios({
          method : "POST",
          url :  api_url + "/UpdateMobileNumberPrivacy",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}